import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import { ButtonBase } from '@material-ui/core'
import { navigate, RoutePath } from '../../../Main'


const useStyles = makeStyles(theme => ({
    root: {
        width: 310,
        height: 410,
        marginTop: 48,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    header: {
        width: '100%',
        height: 95,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#E08900'
    },
    headerTitle: {
        color: '#fff',
        font: 'normal normal 300 28px/22px Roboto'
    },
    headerSubtitle: {
        color: '#fff',
        font: 'normal normal normal 16px/21px Roboto'
    },
    content: {
        width: "100%",
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: '#333333',
        backgroundColor: '#F5F5F5'
    },
    customPrice: {
        marginTop: 39,
        font: 'normal normal normal 27px/35px Roboto',
        textAlign: 'center'
    },
    divider: {
        width: 282,
        height: 1,
        marginTop: 33,
        backgroundColor: '#707070'
    },
    locationsInfo: {
        marginTop: 22,
        font: 'normal normal normal 16px/21px Roboto',
        textAlign: 'center'
    },
    button: {
        width: 200,
        height: 80,
        background: '#E08900',
        border: '1px solid #FFFFFF',
        borderRadius: 16,
        marginTop: -32,
        color: '#fff',
        fontSize: 18,
        fontWeight: 600
    }
}))

export default function SolutionSecondCard(props) {
    const classes = useStyles(props)
    const { t } = useTranslation()

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <div className={classes.headerTitle}>{t("discoverSolutionsSecondCardTitle")}</div>
                <div className={classes.headerSubtitle}>{t("discoverSolutionsSecondCardSubtitle")}</div>
            </div>
            <div className={classes.content}>
                <div className={classes.customPrice}>{t("discoverSolutionsSecondCardCustomPrice")}</div>
                <div className={classes.divider} />
                <div className={classes.locationsInfo}>{t("discoverSolutionsSecondCardLocationsInfo")}</div>
            </div>
            <ButtonBase className={classes.button}
                onClick={() => navigate(props, RoutePath.buyGold)}>
                    {t("discoverSolutionsSecondCardButtonText")}
            </ButtonBase>
        </div>
    )
}